import { TranslateModule } from '@ngx-translate/core';
import { FeatherModule } from 'angular-feather';
import { BadgeColors, BadgeComponent, ButtonComponent, ModalBaseComponent } from 'shared';
import { Component, input, output } from '@angular/core';

@Component({
  selector: 'app-company-status-modal',
  imports: [TranslateModule, FeatherModule, ModalBaseComponent, ButtonComponent, BadgeComponent],
  templateUrl: './company-status-modal.component.html',
  styleUrl: './company-status-modal.component.scss',
})
export class CompanyStatusModalComponent {
  isOpen = input<boolean>(false);
  companyName = input<string>('');
  credentialType = input<string | null>(null);
  isLoading = input<boolean>(false);

  badgeColor = BadgeColors.red;

  closed = output<void>();
  confirmed = output<void>();

  isCredentialRevoke(): boolean {
    return !!this.credentialType();
  }

  onClose(): void {
    if (!this.isLoading()) {
      this.closed.emit();
    }
  }

  onConfirm(): void {
    this.confirmed.emit();
  }
}
